import React, {useEffect, useRef, useState} from "react"
import style from "./DropDown.module.scss"
import BlueCheck from '../../../assets/icons/blueCheckmark.svg'
import Magnifier from '../../../assets/icons/magnifier.svg'
import Switch from "../../SelectionControls/Switch/Switch";

const DropDown = (props) => {

    const wrapperRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false)
    const [dropdownList, setDropdownList] = useState([])
    const [selectedItem, setSelectedItem] = useState([])
    const [searchedWord, setSearchedWord] = useState('')


    const toggleShow = () => {
        // props.action(true);
        setShowDropdown(!showDropdown);
        if (!showDropdown && props.hasCheckbox) {
            let tmp = [];
            if (props.hasCheckbox) {
                tmp = sort(props.dropdownList)
            } else {
                tmp = props.dropdownList;
            }
            setDropdownList(tmp)
        }
    }
    useEffect(() => {
        if (!showDropdown) {
            // props.action(true)
        }
    }, [showDropdown])
    const apply = () => {
        props.action(true);
        toggleShow();
    }

    const sort = (array) => {
        let arr1 = [];
        let arr2 = [];
        array.map(el => {
            if (el.checked === true) {
                arr1.push(el);
            } else {
                arr2.push(el);
            }
        });
        arr1 = arr1.concat(arr2);
        return arr1;
    }

    const handleClickOutside = event => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setShowDropdown(false);
        }
    };

    const searching = e => {
        setSearchedWord(e.target.value);
        props.handleSearch(props.tag, e.target.value);
    }

    const setItem = (e, item) => {
        let dumbItem = [{
            name: 'dumb',
            checked: true,
        }]
        if (!item.checked) {
            setSelectedItem(dumbItem)
        }
    }

    const deleteAll = () => {
        setSelectedItem([""]);
        props.deleteSelectedItems(props.tag);
    }

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, false);
        return () => {
            document.removeEventListener("click", handleClickOutside, false);
        };
    }, []);

    useEffect(() => {
        if (props.dropdownList && props.dropdownList.length !== 0) {
            setDropdownList(props.dropdownList)
        }
    }, [props.dropdownList]);

    return (
        <React.Fragment>
            <div className={style.dropdownWrapper} ref={wrapperRef}>

                <button
                    onClick={toggleShow}
                    className={dropdownList.find(item => item.checked) ? style.dropdownButtonSelected : (showDropdown ? style.dropdownHover : style.dropdownButton)}
                    type="button">
                    {props.placeHolder ? props.placeHolder : 'انتخاب'}
                </button>

                <div className={showDropdown ? style.dropdownContent : style.dropdownContentHide}>
                    {props.hasSearchBox ?
                        <div className={showDropdown ? style.searchWrapper : style.searchHideWrapper}>
                            <img className={style.searchMagnifier} src={Magnifier} alt=''></img>
                            <input
                                type='text'
                                placeholder='جستجو'
                                onChange={e => searching(e)}
                                value={searchedWord}
                                className={style.dropdownSearch}
                            ></input>
                        </div>
                        : null}

                    <ul className={showDropdown ? style.contentDiv : style.contentHideDiv}>

                        {dropdownList.length !== 0 ? dropdownList.map((item, index) =>
                            <li
                                className={selectedItem.includes(item) ? style.itemSelectedWrapper : style.itemNotSelectedWrapper}
                                onClick={props.hasToggle ? null : e => props.handleSelect(props.tag, item)}
                                key={index}>
                                {props.hasCheckbox ?
                                    <div className={style.customCheckboxWrapper}
                                         onMouseDown={e => setItem(e, item)}
                                    >
                                        <input className={item.checked ? style.inputChecked : style.inputCheckboxClass}
                                               type='checkbox'></input>
                                        <p className={style.dropdownItemText}>{item.name ? item.name : item}</p>
                                    </div>
                                    :
                                    (props.hasToggle ?
                                            <div
                                                onMouseDown={e => setSelectedItem([item])}
                                                // onClick={e => props.handleSelect(props.tag, item)}
                                                className={style.toggleWrapper}
                                            >
                                                <p>
                                                    {item.name ? item.name : item}
                                                </p>
                                                <div className={style.switch}>
                                                    <Switch
                                                        value={item.checked}
                                                        indeterminate={false}
                                                        disabled={false}
                                                        tag={index}
                                                        label=''
                                                        onclick={e => props.handleSelect(props.tag, item)}
                                                    />
                                                </div>
                                            </div>
                                            :

                                            <div
                                                onMouseDown={e => setSelectedItem([item])}
                                                onClick={e => props.handleSelect(props.tag, item)}
                                                className={style.customCheckboxWrapper}
                                            >
                                                <p className={style.dropdownItemText}>
                                                    {item.name ? item.name : item}
                                                    {selectedItem.includes(item) ?
                                                        <img className={style.blueCheckMark} src={BlueCheck}
                                                             alt=''></img> : null}
                                                </p>
                                            </div>
                                    )
                                }
                            </li>
                        ) : null}
                    </ul>
                    <div className={showDropdown ? style.dropdownActionsWrapper : style.dropdownActionsWrapperHide}>
                        <button onClick={() => apply()} className={style.addItemAction}>اعمال</button>
                        {selectedItem.length !== 0 ? <button onClick={() => {
                            deleteAll()
                        }} className={style.deleteItemAction}>پاک‌کردن</button> : null}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default DropDown;

/*
*
tag='برند'                               :The tag that will be returned everytime a function inside the component is called(REQUIRED)
label='برند'                             :Label is the text above dropdown and its OPTIONAL
placeHolder='برند'               :Placeholder is the text inside dropdown button and is REQUIRED
dropdownList={array}                    :dropdownList is the items you wish to see when dropdown is clicked( also REQUIRED )
hasSearchBox={true}                     :You can define wether you want to have a search box or not
hasCheckbox={false}                     :Enables you to choose between single-select/multi-select modes
handleSelect={handleSelect}             :HandleSelect must be defined in parent component and will be given "tag" and "value" as function's parameters(REQUIRED)
handleSearch={handleSearch}             :HandleSearch is also defined in parent component and will be given "tag" and "value" as function's parameters
deleteSelectedItems={deleteAll}         :In case you want to delete all the selected values and it must be defined in parent(REQUIRED)
*
 */
